import Vue from 'vue'
Vue.filter('decodeURI', {
	read(s){
		return window.decodeURIComponent(s)
	},
	write(val, oldVal){
		if(val != oldVal){
			return window.encodeURIComponent(val)
		}
	}
})
Vue.filter('init', {
	read: function(s) {
		if(!s){
			s = 0
		}
		return parseInt(s, 10) + 'px'
	},
	// view -> model
	// 在写回数据之前格式化值
	write: function(val, oldVal) {
		if(!/\d+/.test(val)){
			val = 0
		}
		if(val != oldVal){
			return val + 'px'
		}
	}
})
Vue.filter('stringify', JSON.stringify)


// WEBPACK FOOTER //
// ./src/utils/filters.js